var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopied = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2153FD",
  d: "M9.4 5.2h-7c-.772 0-1.4.627-1.4 1.4v7c0 .771.628 1.4 1.4 1.4h7c.772 0 1.4-.629 1.4-1.4v-7c0-.773-.628-1.4-1.4-1.4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2153FD",
  d: "M13.6 1h-7a1.4 1.4 0 0 0-1.4 1.4v1.4h5.6a1.4 1.4 0 0 1 1.4 1.4v5.6h1.4A1.4 1.4 0 0 0 15 9.4v-7A1.4 1.4 0 0 0 13.6 1"
})));
export { SvgCopied as ReactComponent };
export default __webpack_public_path__ + "Copied.6968fd35.svg";